import { ID, ListApiResponse } from '@ianesthesie-kit/services';
import { Intolerance } from './intolerance.model';
import { ListMedicalService, MedicalResponse } from '../baseMedical.service';
import { Emphasis } from '../model';
import axios, { AxiosResponse } from 'axios';

export class IntoleranceService extends ListMedicalService<Intolerance> {
  private static INSTANCE_BY_ID: IntoleranceService;

  private constructor(patientId: string) {
    super('/intolerance', patientId);
  }

  public static getInstance(patientId: ID): IntoleranceService {
    if (this.shouldCreateNewInstance(this.INSTANCE_BY_ID, patientId)) {
      this.INSTANCE_BY_ID = new IntoleranceService(patientId);
    }
    return this.INSTANCE_BY_ID;
  }

  public replace(
    intolerances: Partial<Intolerance>[]
  ): Promise<MedicalResponse<Intolerance, true>> {
    const body = intolerances.map((a) => this.transformToRequestBody(a));
    return axios
      .put(this.url, body)
      .then((response: AxiosResponse<ListApiResponse<Intolerance>>) => ({
        data: response.data.data.map((d) => this.transformResponseEntity(d))
      }))
      .catch((err) => {
        throw this.unwrapErrorDetails(err) || err;
      });
  }

  protected transformToRequestBody(
    d: Partial<Intolerance>
  ): Record<string, unknown> {
    const data: any = { ...d };
    if (data.substanceName && data.substanceName === data.substanceCode) {
      data.substanceCode = undefined;
    } else if (data.substanceCode) {
      data.substanceName = undefined;
    }
    if (!data.emphasis) {
      data.emphasis = Emphasis.INSIGNIFICANT;
    }
    // TODO handle reactions? (both here and the bff as well)
    return super.transformToRequestBody(data);
  }
}
